<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X0gmyU/tc-custom/9781685506780.jpg?1723403856186" alt="This image is the cover for the book Waiting in Line"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Waiting in Line
      </h1>
      <p class="bookDescription body article font2">
        <p>As a personal assistant, Tristan does just about everything for his boss. So, he's not surprised when Dante asks him to travel along to a wedding reception in the country and help the two grooms with their plans. He's not even surprised Dante has requested Gavin, Dante's security officer and Tristan's arch-enemy, to come as well.<br/><br/>Gavin is sexy, smart, struts like a peacock, and does everything he can to drive Tristan crazy on a daily basis. So as much as Gavin's presence was expected, Tristan isn't happy about it, and he's really not happy about having to sleep on a cot in a barn while Gavin gets to stay in the farmhouse in an actual bedroom.<br/><br/>When a little flirting gets Tristan into yet another argument with Gavin, things start to get heated between them -- in a way they never have before. As they start to learn a bit more about each other, Tristan is having a hard time deciding if the country air is messing with his head, or if there's a possibility the disgust he's been feeling for Gavin isn't actually hate at all.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.F. Henley
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a495870